import { registerServiceWorker } from "vue-app-utils-web";

export default registerServiceWorker;